import { useState } from "react";

export const useBadgeModal = () => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return {
        handleOpen,
        handleClose,
        open
    }
}